import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { BusinessAreaModel } from '../business-area.model';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { StatisticService } from '@fi-shared/statistic/statistic.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { ModuleType } from '@fi-shared/types/module-type';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiItemsDeleteHelperService } from '@fi-shared/fi-shared-services/fi-items-delete-helper.service';
import { BusinessAreaService } from '@fi-app/business-area/business-area.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { MoreMenuMobileSettingsModel } from '@fi-app/utilities/more-menu-mobile/more-menu-mobile-settings.model';
import { AppTextService } from '@fi-shared/app-text';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';
import { FiDisplayType } from '@fi-shared/types/display-type';

@Component({
    selector: 'fi-business-area-view',
    templateUrl: './business-area-view.component.html',
    styleUrls: ['./business-area-view.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-business-area-view' },
    standalone: false,
})
export class BusinessAreaViewComponent implements OnInit {
    @Input('businessArea') businessArea: BusinessAreaModel;
    HasEditAccess: boolean = false;
    EditTabs: EditTabsModel;
    MoreMenuItems: MoreMenuMobileSettingsModel;

    constructor(
        private stateAccessCheckService: StateAccessCheckService,
        private statisticService: StatisticService,
        private stateService: FiStateService,
        private itemsDeleteHelperService: FiItemsDeleteHelperService,
        private businessAreaService: BusinessAreaService,
        private appTextService: AppTextService,
        private detectDevicesService: DetectDevicesService,
    ) {}

    ngOnInit() {
        this.setPageHeaderData();
        this.statisticService.Visit(ModuleType.Core, ObjectTypes.BusinessArea, this.businessArea.Id);
    }

    editBusinessArea() {
        this.stateService.go(FiStateNames.BusinessArea.Edit, { Id: this.businessArea.Id });
    }

    deleteBusinessArea() {
        this.itemsDeleteHelperService.commonDeleteConfirm(ObjectTypes.BusinessArea, [this.businessArea]).then(() => {
            this.businessAreaService.deleteBusinessAreas([this.businessArea.Id]).then(() => {
                this.itemsDeleteHelperService.showDeletedObjectSimpleSnackBar(
                    ObjectTypes.BusinessArea,
                    [this.businessArea.Id],
                    this.businessArea.Name,
                );
                window.history.back();
            });
        });
    }

    isMobilePhone(): boolean {
        return this.detectDevicesService.isMobilePhone();
    }

    private setPageHeaderData() {
        this.HasEditAccess = this.stateAccessCheckService.isStateAllowedForCurrentUser(FiStateNames.BusinessArea.Edit);
        this.EditTabs = new EditTabsModel(this.businessArea.Name, this.appTextService.get('back'));
        this.MoreMenuItems = new MoreMenuMobileSettingsModel();

        if (this.HasEditAccess) {
            this.MoreMenuItems.AddListItem(this.appTextService.get('common.edit'), () => this.editBusinessArea());

            this.MoreMenuItems.AddListItem(this.appTextService.get('common.delete'), () => this.deleteBusinessArea());
        }
    }

    protected readonly FiDisplayType = FiDisplayType;
}
